// @ts-nocheck
/* eslint-disable */
import Content from './content';
import { store } from "~/state/store";
import { saveFeedback } from "~/util/providers/feedback";
import MyMapsPopup from "~/es6/mymaps.popup";
import { _ } from "~/i18n";

/**
 * @class Feedback
 * @augments Content
 */
export default class Feedback extends Content {
	/**
	 * Destrukce interního stavu a odvěšení posluchačů událostí
	 */
	destroy() {
		super.destroy();

		this._dom.buttonYes.removeEventListener("click", this, false);
		this._dom.buttonNo.removeEventListener("click", this, false);
		if (this._dom.buttonNote) {
			this._dom.buttonNote.removeEventListener("click", this, false);
		}
	}

	/**
	 * Posluchač událostí
	 * @param {object} e Instance události
	 */
	handleEvent(e) {
		const { user } = store.getState().user;

		if (user.state === "green") {
			this._processEvent(e);
		}
		else {
			Mapy.getComponent("login").open({
				analyticsData: {
					loginOrigin: "trafficPoi",
				},
				motivation: "traffic",
			}).then(() => {
				this._processEvent(e);
			}, () => {});
		}
	}

	/**
	 * Sestavení DOMu a navěšení posluchačů
	 */
	_build() {
		this._dom.container.classList.add("content-feedback");
		this._dom.container.classList.add("noprint");

		const msg = Mapy.Util.node("p", { textContent: _("detail.content.feedback.valid") });
		this._dom.container.appendChild(msg);

		const yes = Mapy.Util.node("button", { type: "button", textContent: _("yes") });
		yes.addEventListener("click", this, false);
		this._dom.container.appendChild(yes);
		this._dom.buttonYes = yes;

		const no = Mapy.Util.node("button", { type: "button", textContent: _("no") });
		no.addEventListener("click", this, false);
		this._dom.container.appendChild(no);
		this._dom.buttonNo = no;
	}

	/**
	 * Skutečné zpracování události, tentokrát je jisté, že je uživatel přihlášený
	 * @param {object} e Instance události
	 */
	_processEvent(e) {
		const { user } = store.getState().user;
		const data = {
			poi_id: this._data.id,
			note: "",
			rus_id: parseInt(user.rusId),
		};

		const afterSave = () => {
			Mapy.Util.clear(this._dom.container);
			this._dom.container.appendChild(Mapy.Util.node("img", { src: "/img/detail/love.svg" }));
			const p = Mapy.Util.node("p", { textContent: _("detail.content.feedback.thanks") });
			this._dom.container.appendChild(p);

			return p;
		};

		switch (e.target) {
			case this._dom.buttonYes:
				this._log("yes");
				saveFeedback(Object.assign({
					action: true,
				}, data)).promise.then(data => { console.log(data); }, () => {}).finally(data => {
					console.log(data);
					afterSave();
				});
				break;

			case this._dom.buttonNo:
				this._log("no");
				saveFeedback(Object.assign({
					action: false,
				}, data)).promise.finally(() => {
					const p = afterSave();

					this._dom.buttonNote = Mapy.Util.node("button", { type: "button", textContent: _("detail.content.feedback.suggest") });
					p.appendChild(this._dom.buttonNote);
					this._dom.buttonNote.addEventListener("click", this, false);
				});
				break;

			case this._dom.buttonNote:
				this._openNotePopup();
				break;
		}
	}

	/**
	 * Loguje akci do analytiky
	 * @param {string} button Tlačítko, které uživatel zmáčkl ("yes" nebo "no")
	 */
	_log(button) {
		Mapy.getComponent("logger").log("trafficFeedback", {
			id: this._data.id,
			name: this._data.title,
			source: this._data.source,
			button: button,
		});
	}

	_openNotePopup() {
		// vytvorime okno
		const popup = new MyMapsPopup({
			name: "feedback-note",
		});

		// sestavime obsah okna
		const frag = Mapy.Util.fragment();
		const textarea = Mapy.Util.node("textarea");
		const send = Mapy.Util.node("button", { type: "button", textContent: _("submit"), className: "primary" });
		const label = Mapy.Util.node("label", { textContent: _("detail.content.feedback.noteLabel") });
		const toolbar = Mapy.Util.node("div", { className: "toolbar" });

		send.addEventListener("click", () => {
			const note = textarea.value.trim();

			// pokud neco napsal, tak to posleme
			if (note.length) {
				const { user } = store.getState().user;

				saveFeedback({
					rus_id: parseInt(user.rusId),
					poi_id: this._data.id,
					action: false,
					note,
				});
			}

			// zavreme psaci popup
			popup.close();

			// vyrobime dekovaci popup
			const thanksPopup = new MyMapsPopup({
				name: "feedback-note",
			});

			const close = Mapy.Util.node("button", { type: "button", textContent: _("close") });
			const toolbar = Mapy.Util.node("div", { className: "toolbar" });

			close.addEventListener("click", () => {
				thanksPopup.close();
			});

			const cont = thanksPopup.getContainer();

			cont.appendChild(Mapy.Util.node("h2", { textContent: _("detail.content.feedback.noteThanksTitle") }));
			toolbar.appendChild(close);
			cont.appendChild(toolbar);

			thanksPopup.open();
		});
		const cancel = Mapy.Util.node("button", { type: "button", textContent: _("cancel") });
		cancel.addEventListener("click", () => {
			popup.close();
		});

		frag.appendChild(Mapy.Util.node("h2", { textContent: _("detail.content.feedback.suggest") }));
		label.appendChild(textarea);
		frag.appendChild(label);
		toolbar.appendChild(send);
		toolbar.appendChild(cancel);
		frag.appendChild(toolbar);
		popup.getContainer().appendChild(frag);

		// otevreme hotove okno
		popup.open();
	};

};
